(() => {
  'use strict';
  if (window.PortafotoLang === 'en') return;

  const isProductPage = () =>
    document.body.classList.contains('template-product') ||
    window.location.pathname.indexOf('/products/') !== -1;

  const setExactText = (root, from, to) => {
    if (!root) return;
    root.querySelectorAll('*').forEach((el) => {
      if (el.children.length === 0 && el.textContent.trim() === from) {
        el.textContent = to;
      }
    });
  };

  const colorMap = {
    black: 'أسود',
    white: 'أبيض',
    wood: 'خشبي',
    'natural wood': 'خشبي طبيعي',
    'dark wood': 'خشبي داكن',
    gold: 'ذهبي',
    golden: 'ذهبي',
    brown: 'بني',
    beige: 'بيج',
    grey: 'رمادي',
    gray: 'رمادي'
  };

  const translateColor = (value) => {
    const raw = String(value || '').trim();
    const key = raw.toLowerCase().replace(/\s+/g, ' ');
    return colorMap[key] || raw;
  };

  const getMainVariantRoot = (root) =>
    root?.querySelector('.productView-product .productView-moreItem-product-variant .productView-variants') ||
    root?.querySelector('.productView-product .productView-variants') ||
    null;

  const translateVariantFieldLabels = (root) => {
    const variantRoot = getMainVariantRoot(root);
    if (!variantRoot) return;

    variantRoot.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
      if (fieldset.closest('.pf-order-pilot')) return;
      const radio = fieldset.querySelector('input.product-form__radio');
      const optionName = (radio?.getAttribute('name') || '').trim().toLowerCase();
      const legend = fieldset.querySelector('legend.form__label');

      fieldset.classList.toggle('portafoto-size-fieldset', optionName === 'size');
      if (!legend) return;

      const firstTextNode = Array.from(legend.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()
      );
      if (!firstTextNode) return;

      if (optionName === 'size') firstTextNode.nodeValue = 'المقاس: ';
      if (optionName === 'color' || optionName === 'colour') firstTextNode.nodeValue = 'لون الإطار: ';
    });

    variantRoot.querySelectorAll('.product-form__input--dropdown').forEach((wrapper) => {
      const select = wrapper.querySelector('select');
      const label = wrapper.querySelector('label.form__label');
      if (!select || !label) return;

      const name = (select.getAttribute('name') || '').toLowerCase();
      wrapper.classList.toggle('portafoto-size-fieldset', name.includes('size'));

      const firstTextNode = Array.from(label.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()
      );
      if (!firstTextNode) return;

      if (name.includes('size')) firstTextNode.nodeValue = 'المقاس: ';
      if (name.includes('color') || name.includes('colour')) firstTextNode.nodeValue = 'لون الإطار: ';
    });
  };

  /* ----------------------------------------------------------------
     Compact size buttons.

     Each size option renders as "3 براويز 40×60 • 2100 EGP" — a string
     long enough that the buttons had to be stacked full-width, which cost
     ~224px on a phone. "3 براويز" also repeats the product title, and the
     currency word repeats on every button.

     Splitting it into a dimension line and a price line lets all three
     sizes sit on one row (measured 110x54 each — comfortably above the
     44px minimum tap target) and drops the block to ~80px.

     The Arabic label text is produced by another script, and it rewrites
     the label when the variant changes. So this checks for the marker
     element rather than setting a one-time flag: if the compact markup is
     gone, it is simply rebuilt.
     ---------------------------------------------------------------- */
  const SIZE_RE = /(\d+)\s*[×xX]\s*(\d+)[^\d]*?(\d[\d,.]*)/;

  const compactSizeLabels = (root) => {
    const variantRoot = getMainVariantRoot(root);
    if (!variantRoot) return;

    variantRoot
      .querySelectorAll('.portafoto-size-fieldset > label.product-form__label')
      .forEach((label) => {
        if (label.querySelector('.pf-size-dim')) return;

        const holder = label.querySelector('.text') || label;
        const raw = holder.textContent.trim().replace(/\s+/g, ' ');
        const match = raw.match(SIZE_RE);
        // Products whose option value carries no dimensions or no price are
        // left exactly as they are rather than guessed at.
        if (!match) return;

        const dim = document.createElement('span');
        dim.className = 'pf-size-dim';
        dim.textContent = match[1] + '×' + match[2];

        const price = document.createElement('span');
        price.className = 'pf-size-price';
        price.textContent = Number(match[3].replace(/[,.]/g, '')).toLocaleString('en-US') + ' ج';

        holder.replaceChildren(dim, price);
      });
  };

  /* The legend repeated the whole selected value ("المقاس: 3 براويز 40×60 •
     2100 EGP") even though the chosen button is outlined right beneath it.
     Trim it to the dimension so the row stays one short line. */
  const compactSizeLegend = (root) => {
    const variantRoot = getMainVariantRoot(root);
    if (!variantRoot) return;

    variantRoot
      .querySelectorAll('.portafoto-size-fieldset > legend [data-header-option]')
      .forEach((el) => {
        const raw = el.textContent.trim().replace(/\s+/g, ' ');
        const match = raw.match(/(\d+)\s*[×xX]\s*(\d+)/);
        if (!match) return;
        const short = match[1] + '×' + match[2];
        if (el.textContent.trim() !== short) el.textContent = short;
      });
  };

  const hideSecondaryClutter = (root) => {
    if (!root) return;
    root.querySelectorAll('.productView-compareColor').forEach((el) => {
      el.style.display = 'none';
    });
  };

  const optionLabelArabic = (name) => {
    const key = String(name || '').trim().toLowerCase();
    if (key === 'size' || key.includes('size')) return 'المقاس';
    if (key === 'color' || key === 'colour' || key.includes('color') || key.includes('colour')) return 'لون الإطار';
    return String(name || '').trim();
  };

  const selectedChoices = (root) => {
    const choices = [];
    const variantRoot = getMainVariantRoot(root);
    if (!variantRoot) return choices;

    variantRoot.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
      const checked = fieldset.querySelector('input.product-form__radio:checked, input[type="radio"]:checked');
      if (!checked) return;

      const optionName = checked.getAttribute('name') || '';
      let label = null;
      if (checked.id) {
        fieldset.querySelectorAll('label[for]').forEach((candidate) => {
          if (candidate.getAttribute('for') === checked.id) label = candidate;
        });
      }
      const visibleText = label?.querySelector('.text')?.textContent?.trim();
      const headerText = fieldset.querySelector('[data-header-option]')?.textContent?.trim();
      let value = visibleText || headerText || checked.value || '';

      if (/colou?r/i.test(optionName)) value = translateColor(checked.value || value);
      if (value) choices.push({ key: optionLabelArabic(optionName), value });
    });

    variantRoot.querySelectorAll('.product-form__input--dropdown').forEach((wrapper) => {
      const select = wrapper.querySelector('select');
      if (!select) return;
      const optionName = (select.getAttribute('name') || '')
        .replace(/^options\[/, '')
        .replace(/\]$/, '');
      let value = select.options[select.selectedIndex]?.textContent?.trim() || select.value || '';
      if (/colou?r/i.test(optionName)) value = translateColor(select.value || value);
      if (value) choices.push({ key: optionLabelArabic(optionName), value });
    });

    return choices;
  };

  /* ----------------------------------------------------------------
     addOrUpdateChoiceSummary is deliberately NOT called any more.

     It rendered a "راجع اختيارك قبل ما تضيف للسلة" panel that restated the
     size and colour the customer had just picked — 154px of the 1055px
     between the title and the Add to cart button, repeating選 selections that
     are visible and highlighted a few centimetres above it.

     Kept here (unused) because it is a complete, working feature: calling it
     again from run() is all that is needed to bring the panel back.
     ---------------------------------------------------------------- */
  const addOrUpdateChoiceSummary = (root) => {
    if (!root) return;

    const addButton = root.querySelector('#product-add-to-cart') || root.querySelector('.product-form__submit');
    if (!addButton) return;

    const buyBlock = addButton.closest('.productView-moreItem') || addButton.closest('form');
    if (!buyBlock || !buyBlock.parentNode) return;

    const choices = selectedChoices(root);
    let summary = root.querySelector('.portafoto-pdp-choice-summary');

    if (!choices.length) {
      if (summary) summary.remove();
      return;
    }

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'portafoto-pdp-choice-summary';
      summary.setAttribute('aria-live', 'polite');
      summary.innerHTML = `
        <div class="portafoto-pdp-choice-summary__label">راجع اختيارك قبل ما تضيف للسلة</div>
        <div class="portafoto-pdp-choice-summary__values"></div>
        <p class="portafoto-pdp-choice-summary__note">السعر المعروض بيتحدث تلقائيًا حسب اختيارك.</p>
      `;
      buyBlock.insertAdjacentElement('beforebegin', summary);
    }

    const values = summary.querySelector('.portafoto-pdp-choice-summary__values');
    if (!values) return;
    values.replaceChildren();

    choices.forEach((choice) => {
      const item = document.createElement('span');
      item.className = 'portafoto-pdp-choice-summary__item';

      const key = document.createElement('span');
      key.className = 'portafoto-pdp-choice-summary__key';
      key.textContent = `${choice.key}:`;

      const value = document.createElement('span');
      value.className = 'portafoto-pdp-choice-summary__value';
      value.textContent = choice.value;

      item.append(key, value);
      values.appendChild(item);
    });
  };

  /* Any panel left over from a previously cached render is cleared once. */
  const removeChoiceSummary = (root) => {
    root?.querySelectorAll('.portafoto-pdp-choice-summary').forEach((el) => el.remove());
  };

  const syncAssuranceWhatsapp = (root) => {
    if (!root) return;
    const block = root.querySelector('.portafoto-pdp-assurance');
    const link = block?.querySelector('.portafoto-pdp-assurance__cta');
    if (!link) return;

    const title = (root.querySelector('.productView-title')?.textContent || document.title || 'Portafoto').trim();
    const canonicalProductUrl = `${window.location.origin}${window.location.pathname}`;
    const whatsappMessage = `محتاج مساعدة أختار المقاس المناسب للمنتج: ${title} ${canonicalProductUrl}`;
    link.href = `https://wa.me/201016826544?text=${encodeURIComponent(whatsappMessage)}`;
  };

  const addAssuranceBlock = (root) => {
    if (!root) return;

    if (root.querySelector('.portafoto-pdp-assurance')) {
      syncAssuranceWhatsapp(root);
      return;
    }

    const addButton = root.querySelector('#product-add-to-cart') || root.querySelector('.product-form__submit');
    if (!addButton) return;

    const buyBlock = addButton.closest('.productView-moreItem') || addButton.closest('form');
    if (!buyBlock || !buyBlock.parentNode) return;

    const title = (root.querySelector('.productView-title')?.textContent || document.title || 'Portafoto').trim();
    const canonicalProductUrl = `${window.location.origin}${window.location.pathname}`;
    const whatsappMessage = `محتاج مساعدة أختار المقاس المناسب للمنتج: ${title} ${canonicalProductUrl}`;
    const whatsappHref = `https://wa.me/201016826544?text=${encodeURIComponent(whatsappMessage)}`;

    const block = document.createElement('div');
    block.className = 'portafoto-pdp-assurance';
    block.innerHTML = `
      <div class="portafoto-pdp-assurance__title">مش متأكد من المقاس؟</div>
      <p class="portafoto-pdp-assurance__text">ابعتلنا صورة الحيطة والمقاس على واتساب، ونرشحلك الاختيار الأنسب قبل ما تطلب.</p>
      <a class="portafoto-pdp-assurance__cta" href="${whatsappHref}" target="_blank" rel="noopener noreferrer">ابعت صورة الحيطة على واتساب</a>
      <ul class="portafoto-pdp-assurance__trust" aria-label="مميزات Portafoto">
        <li>تصميم مخصوص</li>
        <li>تركيب احترافي</li>
        <li>ضمان الجودة</li>
        <li>رد سريع على واتساب</li>
      </ul>
    `;

    buyBlock.insertAdjacentElement('afterend', block);
  };

  const translatePurchaseArea = (root) => {
    if (!root) return;
    [
      ['Size Chart', 'دليل المقاسات'],
      ['Quantity', 'الكمية'],
      ['Add to cart', 'أضف للسلة'],
      ['Add To Cart', 'أضف للسلة']
    ].forEach(([from, to]) => setExactText(root, from, to));
  };

  const run = () => {
    if (!isProductPage()) return;
    const root = document.querySelector('.product-details') || document.querySelector('[id^="ProductSection-"]');
    if (!root) return;

    hideSecondaryClutter(root);
    translatePurchaseArea(root);
    translateVariantFieldLabels(root);
    compactSizeLabels(root);
    compactSizeLegend(root);
    removeChoiceSummary(root);
    addAssuranceBlock(root);
    syncAssuranceWhatsapp(root);
  };

  const boot = () => {
    run();

    const root = document.querySelector('.product-details') || document.querySelector('[id^="ProductSection-"]');
    if (!root) return;

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        run();
      });
    });
    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);

    const variantRoot = getMainVariantRoot(root);
    variantRoot?.addEventListener('change', () => {
      window.requestAnimationFrame(run);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
